import { useInView } from '../hooks';
import styles from './Ecosystem.module.css';

const CHAINS = [
  { name: 'TON Blockchain', color: '#3B82F6' },
  { name: 'Arbitrum',       color: '#12AAFF' },
  { name: 'TRON',           color: '#FF3C00' },
];

export default function Ecosystem({ t }) {
  const [ref, inView] = useInView(0.15);

  return (
    <section className={styles.section} id="ecosystem">
      <div className={styles.inner}>
        <div
          ref={ref}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)', transition: 'all 0.6s ease' }}
        >
          <div className={styles.label}>{t.sectionLabel}</div>
          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.sub}>{t.sub}</p>

          <div className={styles.chains}>
            {CHAINS.map(({ name, color }, i) => (
              <div
                key={name}
                className={styles.badge}
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'none' : 'translateY(12px)',
                  transition: `all 0.5s ease ${0.1 + i * 0.1}s`,
                }}
              >
                <span className={styles.dot} style={{ background: color, boxShadow: `0 0 8px ${color}` }} />
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
